import qs from 'qs'

export const parseDeviceDataFromQrCodeScan = (text: string) => {
  return qs.parse(text.slice(text.lastIndexOf('?')), {
    ignoreQueryPrefix: true,
  })
}
